"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGithubIssueUrl = void 0;
function getGithubIssueUrl(options) {
    var repoUrl;
    if (options.repoUrl) {
        repoUrl = options.repoUrl;
    }
    else if (options.user && options.repo) {
        repoUrl = "https://github.com/" + options.user + "/" + options.repo;
    }
    else {
        throw new Error('You need to specify either the `repoUrl` option or both the `user` and `repo` options');
    }
    var url = new URL(repoUrl + "/issues/new");
    var types = ['body', 'title', 'labels', 'template', 'milestone', 'assignee', 'projects'];
    for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
        var type = types_1[_i];
        var value = options[type];
        if (value === undefined) {
            continue;
        }
        if (type === 'labels' || type === 'projects') {
            if (!Array.isArray(value)) {
                throw new TypeError("The `" + type + "` option should be an array");
            }
            value = value.join(',');
        }
        url.searchParams.set(type, value);
    }
    return url.toString();
}
exports.getGithubIssueUrl = getGithubIssueUrl;
//# sourceMappingURL=index.js.map